import { render, staticRenderFns } from "./MarketingMaterialsOrderConfirmation.vue?vue&type=template&id=e4ee9084&"
import script from "./MarketingMaterialsOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./MarketingMaterialsOrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports